import { createFileRoute } from '@tanstack/react-router'

import { AutomationsProductPage } from '#/modules/intake/automations-product-page'

export const Route = createFileRoute('/_shell/automations')({
  component: AutomationsProductPage,
})
